import {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios';
import {CapacitorHttp} from "@capacitor/core";

export const capacitorAxiosAdapter = async (config: AxiosRequestConfig):
    Promise<AxiosResponse> => {
    try {
        const method = config.method?.toUpperCase() || 'GET';
        const options: any = {
            //url: "https://merchantcenter.fiservapp.com"+config.url,
            url: "https://testitdviewer.firstdata.com"+config.url,
            headers: config.headers,
            params: config.params,
            data: config.data,
            method:method
        };


        let response;

        response = await CapacitorHttp.request(options);

        var res= {
            data: response.data,
            status: response.status,
            statusText: '',
            headers: response.headers,
            config,
            request: options.request,
        };

        if(response.status> 299 || response.status < 200)
            throw new AxiosError(
                "",
                response.status+"",
                config,
                options.request,
                res
            );

        return res;
    } catch (error) {
        // Return or throw a custom error object
        throw error;
    }
};